module.exports = __webpack_public_path__ + "static/media/footer-logo.1f38670a.png";